// extracted by mini-css-extract-plugin
export default {"button":"styles_button__vNm1Y","form":"styles_form__kf9IL"};